import type {UserMinimal as UserMinimalType} from './../types'
import Model from "~/repository/models/Model";

export default class User extends Model<UserMinimalType>() implements UserMinimalType {
    id: number
    name: string
    username: string;
    avatar: string;
    is_online: boolean;

    initials: string;

    constructor(data: UserMinimalType) {
        super()
        this.id = data.id;
        this.name = data.name
        this.username = data.username
        this.avatar = data.avatar
        this.is_online = data.is_online

        this.initials = this.name.split(' ').map((i) => i.charAt(0).toUpperCase()).join('')
    }
    get onlineStatus() {
        return 'Active 5m ago'
    }
}
